import { SeasonEligibility } from '@sorare/core/src/__generated__/globalTypes';
import { TextSwitch } from '@sorare/core/src/atoms/inputs/TextSwitch';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { SportSeasonalityIcon } from '@sorare/core/src/components/SportSeasonalityIcon';
import { useConfigContext } from '@sorare/core/src/contexts/config';
import { PlayerSearchViewAttributes } from '@sorare/core/src/lib/playerSearchView';

import { useManagePlayerSearchView } from '../useManagePlayerSearchView';

export const SeasonalityToggle = () => {
  const {
    so5: { inSeasonName, allSeasonsName },
  } = useConfigContext();
  const { statsManager, updatePlayerSearchViewAttribute } =
    useManagePlayerSearchView();
  const seasonality = statsManager[PlayerSearchViewAttributes.SEASONALITY];

  return (
    <TextSwitch
      value={seasonality}
      compact
      onChange={v =>
        updatePlayerSearchViewAttribute(
          PlayerSearchViewAttributes.SEASONALITY,
          v
        )
      }
      options={[
        {
          label: (
            <Horizontal>
              <SportSeasonalityIcon seasonality={SeasonEligibility.IN_SEASON} />
              {inSeasonName}
            </Horizontal>
          ),
          value: SeasonEligibility.IN_SEASON,
        },
        {
          label: (
            <Horizontal>
              <SportSeasonalityIcon seasonality={SeasonEligibility.CLASSIC} />
              {allSeasonsName}
            </Horizontal>
          ),
          value: SeasonEligibility.CLASSIC,
        },
      ]}
    />
  );
};
